/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CloneIntegrationVersionRequest,
  CreateIntegrationVersionRequest,
  IntegrationCatalogEntity,
  IntegrationReviewEntity,
  PublishReviewDecisionRequest,
} from '../models/index';
import {
    CloneIntegrationVersionRequestFromJSON,
    CloneIntegrationVersionRequestToJSON,
    CreateIntegrationVersionRequestFromJSON,
    CreateIntegrationVersionRequestToJSON,
    IntegrationCatalogEntityFromJSON,
    IntegrationCatalogEntityToJSON,
    IntegrationReviewEntityFromJSON,
    IntegrationReviewEntityToJSON,
    PublishReviewDecisionRequestFromJSON,
    PublishReviewDecisionRequestToJSON,
} from '../models/index';

export interface AddReviewRequest {
    integrationId: string;
    integrationReviewEntity: IntegrationReviewEntity;
    sessionId?: string;
}

export interface CloneToNewVersionRequest {
    integrationId: string;
    cloneIntegrationVersionRequest: CloneIntegrationVersionRequest;
    sessionId?: string;
}

export interface CreateIntegrationRequest {
    integrationCatalogEntity: IntegrationCatalogEntity;
    sessionId?: string;
}

export interface CreateVersionRequest {
    integrationId: string;
    createIntegrationVersionRequest: CreateIntegrationVersionRequest;
    sessionId?: string;
}

export interface GetAllIntegrationsRequest {
    sessionId?: string;
}

export interface GetCatalogStatisticsRequest {
    sessionId?: string;
}

export interface GetIntegrationRequest {
    id: string;
    sessionId?: string;
}

export interface GetIntegrationCapabilitiesRequest {
    sessionId?: string;
    tenantId?: string;
}

export interface GetIntegrationsByCategoryRequest {
    category: string;
    sessionId?: string;
}

export interface GetLatestVersionRequest {
    integrationId: string;
    sessionId?: string;
}

export interface GetReviewsRequest {
    integrationId: string;
    sessionId?: string;
}

export interface GetTopRatedIntegrationsRequest {
    limit?: number;
    sessionId?: string;
}

export interface GetVersionsRequest {
    integrationId: string;
    sessionId?: string;
}

export interface ListCatalogAuditRequest {
    id: string;
    sessionId?: string;
}

export interface ListMyContributorIntegrationsRequest {
    sessionId?: string;
}

export interface ListPendingReviewRequest {
    sessionId?: string;
}

export interface PublishIntegrationRequest {
    id: string;
    sessionId?: string;
}

export interface RejectPublishRequest {
    id: string;
    sessionId?: string;
    publishReviewDecisionRequest?: PublishReviewDecisionRequest;
}

export interface SearchIntegrationsRequest {
    q: string;
    sessionId?: string;
}

export interface SubmitForReviewRequest {
    id: string;
    sessionId?: string;
}

export interface UnpublishIntegrationRequest {
    id: string;
    sessionId?: string;
}

/**
 * IntegrationMarketplaceCatalogApi - interface
 * 
 * @export
 * @interface IntegrationMarketplaceCatalogApiInterface
 */
export interface IntegrationMarketplaceCatalogApiInterface {
    /**
     * Add a review and rating for an integration
     * @summary Add review
     * @param {string} integrationId Integration ID
     * @param {IntegrationReviewEntity} integrationReviewEntity 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceCatalogApiInterface
     */
    addReviewRaw(requestParameters: AddReviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Add a review and rating for an integration
     * Add review
     */
    addReview(requestParameters: AddReviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Updates catalog schema/capabilities/mappings and creates a new version row
     * @summary Clone integration to new version
     * @param {string} integrationId 
     * @param {CloneIntegrationVersionRequest} cloneIntegrationVersionRequest 
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceCatalogApiInterface
     */
    cloneToNewVersionRaw(requestParameters: CloneToNewVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Updates catalog schema/capabilities/mappings and creates a new version row
     * Clone integration to new version
     */
    cloneToNewVersion(requestParameters: CloneToNewVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Create a new integration in the catalog (contributor or admin)
     * @summary Create integration
     * @param {IntegrationCatalogEntity} integrationCatalogEntity 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceCatalogApiInterface
     */
    createIntegrationRaw(requestParameters: CreateIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Create a new integration in the catalog (contributor or admin)
     * Create integration
     */
    createIntegration(requestParameters: CreateIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Creates a version row with source_code for Python/TypeScript integrations
     * @summary Create integration version
     * @param {string} integrationId 
     * @param {CreateIntegrationVersionRequest} createIntegrationVersionRequest 
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceCatalogApiInterface
     */
    createVersionRaw(requestParameters: CreateVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Creates a version row with source_code for Python/TypeScript integrations
     * Create integration version
     */
    createVersion(requestParameters: CreateVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Lists all published integrations in the marketplace
     * @summary Get all integrations
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceCatalogApiInterface
     */
    getAllIntegrationsRaw(requestParameters: GetAllIntegrationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Lists all published integrations in the marketplace
     * Get all integrations
     */
    getAllIntegrations(requestParameters: GetAllIntegrationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Get overall marketplace statistics
     * @summary Get catalog statistics
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceCatalogApiInterface
     */
    getCatalogStatisticsRaw(requestParameters: GetCatalogStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get overall marketplace statistics
     * Get catalog statistics
     */
    getCatalogStatistics(requestParameters: GetCatalogStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Get detailed information about a specific integration
     * @summary Get integration by ID
     * @param {string} id Integration ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceCatalogApiInterface
     */
    getIntegrationRaw(requestParameters: GetIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get detailed information about a specific integration
     * Get integration by ID
     */
    getIntegration(requestParameters: GetIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Retrieves capabilities for all integrations from INTEGRATION_SCHEMAS configuration
     * @summary Get integration capabilities
     * @param {string} [sessionId] Session ID for authorization
     * @param {string} [tenantId] Tenant ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceCatalogApiInterface
     */
    getIntegrationCapabilitiesRaw(requestParameters: GetIntegrationCapabilitiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Retrieves capabilities for all integrations from INTEGRATION_SCHEMAS configuration
     * Get integration capabilities
     */
    getIntegrationCapabilities(requestParameters: GetIntegrationCapabilitiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Lists all integrations in a specific category (e.g., SIEM, VM, TI)
     * @summary Get integrations by category
     * @param {string} category Category (SIEM, VM, TI, ITSM, etc.)
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceCatalogApiInterface
     */
    getIntegrationsByCategoryRaw(requestParameters: GetIntegrationsByCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Lists all integrations in a specific category (e.g., SIEM, VM, TI)
     * Get integrations by category
     */
    getIntegrationsByCategory(requestParameters: GetIntegrationsByCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Get the latest version of an integration
     * @summary Get latest version
     * @param {string} integrationId Integration ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceCatalogApiInterface
     */
    getLatestVersionRaw(requestParameters: GetLatestVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get the latest version of an integration
     * Get latest version
     */
    getLatestVersion(requestParameters: GetLatestVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Get all approved reviews for an integration
     * @summary Get reviews
     * @param {string} integrationId Integration ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceCatalogApiInterface
     */
    getReviewsRaw(requestParameters: GetReviewsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get all approved reviews for an integration
     * Get reviews
     */
    getReviews(requestParameters: GetReviewsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Lists integrations sorted by rating
     * @summary Get top-rated integrations
     * @param {number} [limit] Max number of results
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceCatalogApiInterface
     */
    getTopRatedIntegrationsRaw(requestParameters: GetTopRatedIntegrationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Lists integrations sorted by rating
     * Get top-rated integrations
     */
    getTopRatedIntegrations(requestParameters: GetTopRatedIntegrationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Lists all versions of an integration
     * @summary Get integration versions
     * @param {string} integrationId Integration ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceCatalogApiInterface
     */
    getVersionsRaw(requestParameters: GetVersionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Lists all versions of an integration
     * Get integration versions
     */
    getVersions(requestParameters: GetVersionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * 
     * @summary List catalog lifecycle audit events
     * @param {string} id 
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceCatalogApiInterface
     */
    listCatalogAuditRaw(requestParameters: ListCatalogAuditRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * List catalog lifecycle audit events
     */
    listCatalogAudit(requestParameters: ListCatalogAuditRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * 
     * @summary List my contributor catalog entries
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceCatalogApiInterface
     */
    listMyContributorIntegrationsRaw(requestParameters: ListMyContributorIntegrationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * List my contributor catalog entries
     */
    listMyContributorIntegrations(requestParameters: ListMyContributorIntegrationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * 
     * @summary List integrations pending publish review
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceCatalogApiInterface
     */
    listPendingReviewRaw(requestParameters: ListPendingReviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * List integrations pending publish review
     */
    listPendingReview(requestParameters: ListPendingReviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Approves a PENDING_REVIEW entry and makes it visible in the marketplace
     * @summary Approve and publish integration
     * @param {string} id Integration ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceCatalogApiInterface
     */
    publishIntegrationRaw(requestParameters: PublishIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Approves a PENDING_REVIEW entry and makes it visible in the marketplace
     * Approve and publish integration
     */
    publishIntegration(requestParameters: PublishIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * 
     * @summary Reject publish request
     * @param {string} id 
     * @param {string} [sessionId] 
     * @param {PublishReviewDecisionRequest} [publishReviewDecisionRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceCatalogApiInterface
     */
    rejectPublishRaw(requestParameters: RejectPublishRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Reject publish request
     */
    rejectPublish(requestParameters: RejectPublishRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Search integrations by name or description
     * @summary Search integrations
     * @param {string} q Search term
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceCatalogApiInterface
     */
    searchIntegrationsRaw(requestParameters: SearchIntegrationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Search integrations by name or description
     * Search integrations
     */
    searchIntegrations(requestParameters: SearchIntegrationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * 
     * @summary Submit integration for publish review
     * @param {string} id 
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceCatalogApiInterface
     */
    submitForReviewRaw(requestParameters: SubmitForReviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Submit integration for publish review
     */
    submitForReview(requestParameters: SubmitForReviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Remove integration from marketplace visibility (admin only)
     * @summary Unpublish integration
     * @param {string} id Integration ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceCatalogApiInterface
     */
    unpublishIntegrationRaw(requestParameters: UnpublishIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Remove integration from marketplace visibility (admin only)
     * Unpublish integration
     */
    unpublishIntegration(requestParameters: UnpublishIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

}

/**
 * 
 */
export class IntegrationMarketplaceCatalogApi extends runtime.BaseAPI implements IntegrationMarketplaceCatalogApiInterface {

    /**
     * Add a review and rating for an integration
     * Add review
     */
    async addReviewRaw(requestParameters: AddReviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling addReview().'
            );
        }

        if (requestParameters['integrationReviewEntity'] == null) {
            throw new runtime.RequiredError(
                'integrationReviewEntity',
                'Required parameter "integrationReviewEntity" was null or undefined when calling addReview().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/marketplace/catalog/{integrationId}/reviews`;
        urlPath = urlPath.replace(`{${"integrationId"}}`, encodeURIComponent(String(requestParameters['integrationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IntegrationReviewEntityToJSON(requestParameters['integrationReviewEntity']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Add a review and rating for an integration
     * Add review
     */
    async addReview(requestParameters: AddReviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.addReviewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates catalog schema/capabilities/mappings and creates a new version row
     * Clone integration to new version
     */
    async cloneToNewVersionRaw(requestParameters: CloneToNewVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling cloneToNewVersion().'
            );
        }

        if (requestParameters['cloneIntegrationVersionRequest'] == null) {
            throw new runtime.RequiredError(
                'cloneIntegrationVersionRequest',
                'Required parameter "cloneIntegrationVersionRequest" was null or undefined when calling cloneToNewVersion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/marketplace/catalog/{integrationId}/versions/clone`;
        urlPath = urlPath.replace(`{${"integrationId"}}`, encodeURIComponent(String(requestParameters['integrationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CloneIntegrationVersionRequestToJSON(requestParameters['cloneIntegrationVersionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Updates catalog schema/capabilities/mappings and creates a new version row
     * Clone integration to new version
     */
    async cloneToNewVersion(requestParameters: CloneToNewVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.cloneToNewVersionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new integration in the catalog (contributor or admin)
     * Create integration
     */
    async createIntegrationRaw(requestParameters: CreateIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['integrationCatalogEntity'] == null) {
            throw new runtime.RequiredError(
                'integrationCatalogEntity',
                'Required parameter "integrationCatalogEntity" was null or undefined when calling createIntegration().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/marketplace/catalog`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IntegrationCatalogEntityToJSON(requestParameters['integrationCatalogEntity']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Create a new integration in the catalog (contributor or admin)
     * Create integration
     */
    async createIntegration(requestParameters: CreateIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.createIntegrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a version row with source_code for Python/TypeScript integrations
     * Create integration version
     */
    async createVersionRaw(requestParameters: CreateVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling createVersion().'
            );
        }

        if (requestParameters['createIntegrationVersionRequest'] == null) {
            throw new runtime.RequiredError(
                'createIntegrationVersionRequest',
                'Required parameter "createIntegrationVersionRequest" was null or undefined when calling createVersion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/marketplace/catalog/{integrationId}/versions`;
        urlPath = urlPath.replace(`{${"integrationId"}}`, encodeURIComponent(String(requestParameters['integrationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateIntegrationVersionRequestToJSON(requestParameters['createIntegrationVersionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Creates a version row with source_code for Python/TypeScript integrations
     * Create integration version
     */
    async createVersion(requestParameters: CreateVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.createVersionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Lists all published integrations in the marketplace
     * Get all integrations
     */
    async getAllIntegrationsRaw(requestParameters: GetAllIntegrationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/marketplace/catalog`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Lists all published integrations in the marketplace
     * Get all integrations
     */
    async getAllIntegrations(requestParameters: GetAllIntegrationsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getAllIntegrationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get overall marketplace statistics
     * Get catalog statistics
     */
    async getCatalogStatisticsRaw(requestParameters: GetCatalogStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/marketplace/catalog/statistics`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get overall marketplace statistics
     * Get catalog statistics
     */
    async getCatalogStatistics(requestParameters: GetCatalogStatisticsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getCatalogStatisticsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get detailed information about a specific integration
     * Get integration by ID
     */
    async getIntegrationRaw(requestParameters: GetIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getIntegration().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/marketplace/catalog/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get detailed information about a specific integration
     * Get integration by ID
     */
    async getIntegration(requestParameters: GetIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getIntegrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves capabilities for all integrations from INTEGRATION_SCHEMAS configuration
     * Get integration capabilities
     */
    async getIntegrationCapabilitiesRaw(requestParameters: GetIntegrationCapabilitiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['tenantId'] != null) {
            queryParameters['tenantId'] = requestParameters['tenantId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/marketplace/catalog/capabilities`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Retrieves capabilities for all integrations from INTEGRATION_SCHEMAS configuration
     * Get integration capabilities
     */
    async getIntegrationCapabilities(requestParameters: GetIntegrationCapabilitiesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getIntegrationCapabilitiesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Lists all integrations in a specific category (e.g., SIEM, VM, TI)
     * Get integrations by category
     */
    async getIntegrationsByCategoryRaw(requestParameters: GetIntegrationsByCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['category'] == null) {
            throw new runtime.RequiredError(
                'category',
                'Required parameter "category" was null or undefined when calling getIntegrationsByCategory().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/marketplace/catalog/category/{category}`;
        urlPath = urlPath.replace(`{${"category"}}`, encodeURIComponent(String(requestParameters['category'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Lists all integrations in a specific category (e.g., SIEM, VM, TI)
     * Get integrations by category
     */
    async getIntegrationsByCategory(requestParameters: GetIntegrationsByCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getIntegrationsByCategoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the latest version of an integration
     * Get latest version
     */
    async getLatestVersionRaw(requestParameters: GetLatestVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling getLatestVersion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/marketplace/catalog/{integrationId}/versions/latest`;
        urlPath = urlPath.replace(`{${"integrationId"}}`, encodeURIComponent(String(requestParameters['integrationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get the latest version of an integration
     * Get latest version
     */
    async getLatestVersion(requestParameters: GetLatestVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getLatestVersionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all approved reviews for an integration
     * Get reviews
     */
    async getReviewsRaw(requestParameters: GetReviewsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling getReviews().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/marketplace/catalog/{integrationId}/reviews`;
        urlPath = urlPath.replace(`{${"integrationId"}}`, encodeURIComponent(String(requestParameters['integrationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get all approved reviews for an integration
     * Get reviews
     */
    async getReviews(requestParameters: GetReviewsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getReviewsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Lists integrations sorted by rating
     * Get top-rated integrations
     */
    async getTopRatedIntegrationsRaw(requestParameters: GetTopRatedIntegrationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/marketplace/catalog/top-rated`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Lists integrations sorted by rating
     * Get top-rated integrations
     */
    async getTopRatedIntegrations(requestParameters: GetTopRatedIntegrationsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getTopRatedIntegrationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Lists all versions of an integration
     * Get integration versions
     */
    async getVersionsRaw(requestParameters: GetVersionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling getVersions().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/marketplace/catalog/{integrationId}/versions`;
        urlPath = urlPath.replace(`{${"integrationId"}}`, encodeURIComponent(String(requestParameters['integrationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Lists all versions of an integration
     * Get integration versions
     */
    async getVersions(requestParameters: GetVersionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getVersionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List catalog lifecycle audit events
     */
    async listCatalogAuditRaw(requestParameters: ListCatalogAuditRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling listCatalogAudit().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/marketplace/catalog/{id}/audit`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * List catalog lifecycle audit events
     */
    async listCatalogAudit(requestParameters: ListCatalogAuditRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.listCatalogAuditRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List my contributor catalog entries
     */
    async listMyContributorIntegrationsRaw(requestParameters: ListMyContributorIntegrationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/marketplace/catalog/contributor/mine`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * List my contributor catalog entries
     */
    async listMyContributorIntegrations(requestParameters: ListMyContributorIntegrationsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.listMyContributorIntegrationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List integrations pending publish review
     */
    async listPendingReviewRaw(requestParameters: ListPendingReviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/marketplace/catalog/pending-review`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * List integrations pending publish review
     */
    async listPendingReview(requestParameters: ListPendingReviewRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.listPendingReviewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Approves a PENDING_REVIEW entry and makes it visible in the marketplace
     * Approve and publish integration
     */
    async publishIntegrationRaw(requestParameters: PublishIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling publishIntegration().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/marketplace/catalog/{id}/publish`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Approves a PENDING_REVIEW entry and makes it visible in the marketplace
     * Approve and publish integration
     */
    async publishIntegration(requestParameters: PublishIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.publishIntegrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Reject publish request
     */
    async rejectPublishRaw(requestParameters: RejectPublishRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rejectPublish().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/marketplace/catalog/{id}/reject-publish`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PublishReviewDecisionRequestToJSON(requestParameters['publishReviewDecisionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Reject publish request
     */
    async rejectPublish(requestParameters: RejectPublishRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.rejectPublishRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search integrations by name or description
     * Search integrations
     */
    async searchIntegrationsRaw(requestParameters: SearchIntegrationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['q'] == null) {
            throw new runtime.RequiredError(
                'q',
                'Required parameter "q" was null or undefined when calling searchIntegrations().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/marketplace/catalog/search`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Search integrations by name or description
     * Search integrations
     */
    async searchIntegrations(requestParameters: SearchIntegrationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.searchIntegrationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Submit integration for publish review
     */
    async submitForReviewRaw(requestParameters: SubmitForReviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling submitForReview().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/marketplace/catalog/{id}/submit-for-review`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Submit integration for publish review
     */
    async submitForReview(requestParameters: SubmitForReviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.submitForReviewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Remove integration from marketplace visibility (admin only)
     * Unpublish integration
     */
    async unpublishIntegrationRaw(requestParameters: UnpublishIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling unpublishIntegration().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/marketplace/catalog/{id}/unpublish`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Remove integration from marketplace visibility (admin only)
     * Unpublish integration
     */
    async unpublishIntegration(requestParameters: UnpublishIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.unpublishIntegrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
